import { TripID } from "../../trips/trip.interface"
import { UserID } from "../../user/user.interface"
import { TokenizedCreditCardID } from "../credit-card/credit-card.types"
import {
  PaymentMethodDisplayType,
  PaymentMethodProvider,
  PaymentMethodType,
} from "./payment-method.types"
import { PaymentLineItemID } from "./payment-line-item.types"

export type PaymentTransactionID = string

export enum PaymentTransactionStatusEnum {
  ACHProcessing = "ACHProcessing", // ACH payment is in progress
  ACHFailed = "ACHFailed", // ACH payment failed
  Approved = "approved", // payment method is ready for agent
  Succeeded = "succeeded",
  Cancelled = "cancelled",
  Failed = "failed",
}

export type PaymentTransactionStatus =
  | `${PaymentTransactionStatusEnum}`
  | PaymentTransactionStatusEnum

export enum PaymentTransactionTypeEnum {
  CreditCardTotalPayment = "creditCardTotalPayment",
  CreditCardDepositPayment = "creditCardDepositPayment",
  BankAccountTotalPayment = "bankAccountTotalPayment",
  BankAccountTotalSplitPayment = "bankAccountTotalSplitPayment",
  BankAccountDepositPayment = "bankAccountDepositPayment",
}

export type PaymentTransactionType = `${PaymentTransactionTypeEnum}` | PaymentTransactionTypeEnum
export type PaymentTransactionMeta = Record<string, string>

export type PaymentTransaction<TMeta = PaymentTransactionMeta> = {
  id: PaymentTransactionID

  status: PaymentTransactionStatus
  type: PaymentTransactionType

  userId: UserID
  tripId: TripID

  currency: string
  amount: string

  lineItemId: PaymentLineItemID

  paymentMethodProvider: PaymentMethodProvider

  paymentMethodType: PaymentMethodType
  paymentMethodDisplayType: PaymentMethodDisplayType
  paymentMethodDisplayName: string

  // Credit card related data
  creditCardId?: TokenizedCreditCardID | string
  creditCardTokenId?: string

  // Stripe ACH
  stripeCustomerId?: string
  stripePaymentIntentId?: string
  stripePaymentIntentStatus?: string
  stripePaymentIntentStatusDate?: Date

  created: Date
  createdBy: UserID

  updated: Date
  updatedBy: UserID

  meta: TMeta
}
